import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImageDetail from './ImageDetail'
import Loading from '../../generic/Loading'

class ImagesGallery extends Component {
	render() {
		const { images, loading, selectedClientId } = this.props.sharedState
		
		return (
			<div className="images-gallery">
				{/* Instructions */}
				{!selectedClientId && (
					<div className="gallery-instructions">
						<p>Please select a client and search for images in the Overview tab first.</p>
					</div>
				)}

				{/* Loading State */}
				{loading && (
					<div className="loading-container">
						<Loading />
					</div>
				)}

				{/* Gallery Grid */}
				{!loading && images && images.length > 0 && (
					<div className="images-gallery-grid">
						{images.map((image, index) => (
							<ImageDetail
								key={image.image_id || index}
								image={image}
								size="800x600"
							/>
						))}
					</div>
				)}

				{/* Empty State */}
				{!loading && selectedClientId && images && images.length === 0 && (
					<div className="gallery-empty-state">
						<p>No images found. Try searching in the Overview tab.</p>
					</div>
				)}
			</div>
		)
	}
}

ImagesGallery.propTypes = {
	client_ids: PropTypes.array.isRequired,
	sharedState: PropTypes.object.isRequired,
	updateSharedState: PropTypes.func.isRequired,
}

ImagesGallery.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default ImagesGallery
